import Responsive from './Responsive';

module.exports = function() {
	const r = new Responsive();

	$('[type="radio"]').click(function() {
		$('[type="radio"]').next().removeClass('active');

		if($(this).parent('label').index() !== 0  && $(this).prop('checked')){
			$('.hidden_select').slideUp(300);
			$('select[name="mwf_subject_1"] option:selected ,select[name="mwf_subject_2"] option:selected ,select[name="mwf_subject_3"] option:selected ,select[name="mwf_subject_4"] option:selected ,select[name="mwf_subject_5"] option:selected').attr('selected',false);
			$('.dummy_input').val('');
		}

		if($(this).prop('checked')) {
			$(this).next().addClass('active');
			$(this).parent('label').next('.hidden_select').slideDown(300);
		}
	});

	$('.dummy_select select').change(function(){
		let val = $(this).find('option:selected').val();
		console.log(val);
		$(this).prev().val(val);
	});

	if($('.mw_wp_form_preview .confirm_show').find('input[name="mwf_subject"]').val() =="案件に関するご相談・お問い合わせ"){
		$('.hidden_select').show();
	}

	$('.mw_wp_form_input').find('.contact_flow-list li').eq(0).addClass('active');
	$('.mw_wp_form_preview').find('.contact_flow-list li').eq(1).addClass('active');
}



// WEBPACK FOOTER //
// ./dev/js/scripts/form_support.js